import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function MariaBot() {
  const navigate = useNavigate();
  const [inputMessage, setInputMessage] = useState("");
  const [messages, setMessages] = useState([
    {
      id: 1,
      sender: "maria",
      text: "Olá! Sou a MarIA ✨ Sua assistente virtual de saúde. Como posso te orientar hoje sobre o uso do MariaM, doses ou hábitos?",
    },
  ]);
  const messagesEndRef = useRef(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  const quickQuestions = [
    { label: "⚖️ Registrar Peso", text: "Como faço para registrar meu peso?" },
    { label: "📅 Rotina de Doses", text: "Como funciona o controle de doses e rotina?" },
    { label: "🎯 Editar Metas", text: "Como editar minhas metas e prazos?" },
    { label: "🩺 Pressão Arterial", text: "Como registrar a pressão arterial?" },
  ];

  const handleSendMessage = (textToSend) => {
    const query = textToSend || inputMessage.trim();
    if (!query) return;

    const userMsg = {
      id: Date.now(),
      sender: "user",
      text: query,
    };

    setMessages((prev) => [...prev, userMsg]);
    if (!textToSend) setInputMessage("");

    setTimeout(() => {
      let reply = "Para navegar no sistema, utilize a barra de menu na parte inferior ou toque no card correspondente na tela Início!";
      const lower = query.toLowerCase();

      if (lower.includes("peso")) {
        reply = "Para registrar seu peso, toque no card 'Peso' na tela inicial ou navegue até Registros > Peso. Lá você poderá atualizar seu peso, ver o histórico e definir sua meta!";
      } else if (lower.includes("rotina") || lower.includes("dose") || lower.includes("medicação")) {
        reply = "Na aba 'Rotina' (ícone de calendário no menu inferior), você acompanha os horários de doses do dia e confirma a tomada em 1 toque com direito a confete 🎉!";
      } else if (lower.includes("meta") || lower.includes("prazos")) {
        reply = "Na página dedicada de cada medição (Peso, Pressão, Glicemia, Medidas), você encontrará o card 'Meta' com o botão 'Editar Meta' para ajustar a frequência desejada (1, 3, 7, 14 ou 30 dias).";
      } else if (lower.includes("pressão") || lower.includes("glicemia")) {
        reply = "Para registrar Pressão Arterial ou Glicemia, acesse o card correspondente na Home e digite os valores medidos.";
      }

      const mariaMsg = {
        id: Date.now() + 1,
        sender: "maria",
        text: reply,
      };

      setMessages((prev) => [...prev, mariaMsg]);
    }, 600);
  };

  return (
    <div className="space-y-3">
      {/* BOTÃO DE VOLTAR */}
      <button
        type="button"
        onClick={() => navigate(-1)}
        className="inline-flex items-center gap-2 text-xs font-bold text-[#6C54D8] hover:text-[#24152F] transition-colors py-1 group cursor-pointer"
      >
        <svg className="w-4 h-4 transition-transform group-hover:-translate-x-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M15 19l-7-7 7-7" />
        </svg>
        Voltar
      </button>

      {/* CONTAINER DO CHAT DA MARIA */}
      <div className="bg-white rounded-3xl shadow-md border border-purple-100 flex flex-col h-[520px] overflow-hidden">
        {/* CABEÇALHO DA ASSISTENTE */}
        <div className="bg-gradient-to-r from-[#6C54D8] via-[#7B63E4] to-[#917CF0] p-4 text-white flex items-center justify-between shadow-xs shrink-0">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-2xl bg-white/20 backdrop-blur-md flex items-center justify-center text-xl shadow-inner border border-white/30">
              🤖
            </div>
            <div>
              <h1 className="text-base font-bold leading-tight">MarIA Assistente Virtual</h1>
              <p className="text-[11px] text-purple-100 flex items-center gap-1 font-medium">
                <span className="w-2 h-2 rounded-full bg-emerald-400 animate-pulse" /> Ativa para tirar dúvidas
              </p>
            </div>
          </div>
        </div>

        {/* CORPO DE MENSAGENS */}
        <div className="flex-1 p-4 overflow-y-auto space-y-3 bg-[#FAFAFE]">
          {messages.map((msg) => (
            <div
              key={msg.id}
              className={`flex items-start gap-2.5 ${
                msg.sender === "user" ? "justify-end ml-auto max-w-[85%]" : "max-w-[88%]"
              }`}
            >
              {msg.sender === "maria" && (
                <div className="w-8 h-8 rounded-xl bg-purple-100 flex items-center justify-center text-sm shrink-0 font-bold border border-purple-200">
                  🤖
                </div>
              )}

              <div
                className={`p-3.5 text-xs leading-relaxed ${
                  msg.sender === "user"
                    ? "bg-[#6C54D8] text-white rounded-2xl rounded-br-xs font-semibold shadow-xs"
                    : "bg-white text-[#24152F] rounded-2xl rounded-tl-xs shadow-2xs border border-purple-100/80 font-medium space-y-1"
                }`}
              >
                {msg.text}
              </div>
            </div>
          ))}
          <div ref={messagesEndRef} />
        </div>

        {/* PÍLULAS DE ATALHO RÁPIDO */}
        <div className="px-3 py-2 bg-white border-t border-purple-50 flex items-center gap-1.5 overflow-x-auto text-xs shrink-0 no-scrollbar">
          {quickQuestions.map((q, idx) => (
            <button
              key={idx}
              onClick={() => handleSendMessage(q.text)}
              className="px-3 py-1.5 rounded-full bg-purple-50 hover:bg-purple-100 text-[#6C54D8] font-bold text-[11px] whitespace-nowrap transition-colors border border-purple-200/60 cursor-pointer"
            >
              {q.label}
            </button>
          ))}
        </div>

        {/* INPUT DE MENSAGEM */}
        <form
          onSubmit={(e) => {
            e.preventDefault();
            handleSendMessage();
          }}
          className="p-3 bg-white border-t border-purple-100 flex items-center gap-2 shrink-0"
        >
          <input
            type="text"
            value={inputMessage}
            onChange={(e) => setInputMessage(e.target.value)}
            placeholder="Digite sua dúvida sobre o MariaM..."
            className="flex-1 h-11 px-4 rounded-2xl bg-gray-50 border border-purple-100 text-xs font-semibold focus:outline-none focus:border-[#6C54D8] focus:bg-white transition-all"
          />
          <button
            type="submit"
            className="w-11 h-11 rounded-2xl bg-[#6C54D8] hover:bg-[#5A45BF] text-white flex items-center justify-center transition-transform active:scale-95 shadow-md cursor-pointer shrink-0"
          >
            <svg className="w-5 h-5 rotate-90" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M12 19V5m0 0l-7 7m7-7l7 7" />
            </svg>
          </button>
        </form>
      </div>
    </div>
  );
}